import { NgModule }         from '@angular/core';
import { CommonModule }     from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CanvasModule } from '@shared/canvas/canvas.module';

import { BarsChartComponent } from './bars-chart/bars-chart.component';
import { GaugeChartComponent } from './gauge-chart/gauge-chart.component';
import { AverageSchoolScoresChartComponent } from './average-school-scores-chart/average-school-scores-chart.component';
import { LoadingModule } from '@shared/loading/loading.module';
import { SchoolEngagementGaugeChartComponent } from './school-engagement-gauge-chart/school-engagement-gauge-chart.component';
import { AlertBoxModule } from '@shared/alert-box/alert-box.module';


@NgModule({
  declarations: [
    BarsChartComponent,
    GaugeChartComponent,
    AverageSchoolScoresChartComponent,
    SchoolEngagementGaugeChartComponent
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    CanvasModule,
    LoadingModule,
    AlertBoxModule
  ],
  exports:      [
    BarsChartComponent,
    GaugeChartComponent,
    AverageSchoolScoresChartComponent,
    SchoolEngagementGaugeChartComponent
  ]
})
export class ChartsModule {}
